// import React, { useState } from 'react';

// interface DownloadButtonProps {
//   seriesNumberCont: number;
// }
// const ExportImages: React.FC<DownloadButtonProps> = ({ seriesNumberCont }) => {
//   const [showModal, setShowModal] = useState(false);

//   return (
//     <div className="w-full">
//       <button
//         onClick={() => setShowModal(true)}
//         className="hover:text-secondary-light flex h-full w-full justify-center rounded bg-transparent py-2 text-white"
//       >
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           fill="currentColor"
//           className="bi bi-box-arrow-down h-4 w-4 sm:h-8 sm:w-8"
//           viewBox="0 0 16 16"
//         >
//           <path d="M2.95.4a1 1 0 0 1 .8-.4h8.5a1 1 0 0 1 .8.4l2.85 3.8a.5.5 0 0 1 .1.3V15a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4.5a.5.5 0 0 1 .1-.3zM7.5 1H3.75L1.5 4h6zm1 0v3h6l-2.25-3zM15 5H1v10h14z" />
//           <path
//             fillRule="evenodd"
//             d="M7.646 13.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 12.293V7.5a.5.5 0 0 0-1 0v4.793l-2.146-2.147a.5.5 0 0 0-.708.708z"
//           />
//         </svg>
//       </button>
//       {showModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-60 text-white">
//           <div className="bg-secondary-dark max-w-2xl overflow-auto rounded p-6 shadow-lg sm:w-full">
//             <h2 className="mb-4 text-center text-lg font-semibold">{'Estudio sin descripción'}</h2>

//             <div className="mt-4 flex justify-end">
//               <button
//                 onClick={() => setShowModal(false)}
//                 className="rounded bg-gray-600 px-4 py-2 text-white hover:bg-gray-700"
//               >
//                 Cerrar
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// export default ExportImages;

import { DicomMetadataStore } from '@ohif/core';
import React, { useState, useEffect } from 'react';
import { DownloadStudySeries } from '../button/DowloadStudySerie';

const ExportInstances = ({ seriesNumberCont }: { seriesNumberCont: string }) => {
  const [showModal, setShowModal] = useState(false);
  const [study, setStudy] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Cargar el estudio desde el store de OHIF
    const fetchStudy = async () => {
      try {
        const fetchedStudy = DicomMetadataStore.getStudy(seriesNumberCont);

        if (fetchedStudy && fetchedStudy.isLoaded) {
          console.log(fetchedStudy.series);
          setStudy(fetchedStudy);
        } else {
          console.warn('Estudio no encontrado o no cargado aún');
        }
      } catch (error) {
        console.error('Error al cargar el estudio:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudy();
  }, [seriesNumberCont]);

  if (loading) {
    return <div className="p-4 text-white">Cargando datos del estudio...</div>;
  }

  if (!study) {
    return <div className="p-4 text-red-400">No se encontró información del estudio.</div>;
  }

  const seriesList = study.series || [];

  return (
    <div className="w-full">
      <button
        onClick={() => setShowModal(true)}
        className="hover:text-secondary-light flex h-full w-full justify-center rounded bg-transparent py-2 text-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          className="bi bi-box-arrow-down h-4 w-4 sm:h-8 sm:w-8"
          viewBox="0 0 16 16"
        >
          <path d="M2.95.4a1 1 0 0 1 .8-.4h8.5a1 1 0 0 1 .8.4l2.85 3.8a.5.5 0 0 1 .1.3V15a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4.5a.5.5 0 0 1 .1-.3zM7.5 1H3.75L1.5 4h6zm1 0v3h6l-2.25-3zM15 5H1v10h14z" />
          <path
            fillRule="evenodd"
            d="M7.646 13.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 12.293V7.5a.5.5 0 0 0-1 0v4.793l-2.146-2.147a.5.5 0 0 0-.708.708z"
          />
        </svg>
      </button>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-60 text-white">
          <div className="bg-secondary-dark max-w-2xl overflow-auto rounded p-6 shadow-lg sm:w-full">
            <h2 className="mb-4 text-center text-lg font-semibold">
              {study.StudyDescription || 'Estudio sin descripción'}
            </h2>
            <table className="min-w-full bg-white text-left text-sm text-gray-700">
              <thead className="bg-gray-200 text-gray-900">
                <tr>
                  <th className="px-6 py-3">Descripción</th>
                  <th className="px-6 py-3"># Instancias</th>
                  <th className="px-6 py-3">Modalidad</th>
                  <th className="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {seriesList.map((serie: any, index: number) => (
                  <tr
                    key={serie.SeriesInstanceUID || index}
                    className="border-b hover:bg-gray-100"
                  >
                    <td className="px-6 py-4">{serie.SeriesDescription || 'Sin descripción'}</td>
                    <td className="px-6 py-4">
                      {serie.instances?.length || serie.NumberOfSeriesRelatedInstances || 0}
                    </td>
                    <td className="px-6 py-4">{serie.Modality || 'N/A'}</td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => console.log('Enviar serie:', serie.SeriesInstanceUID)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <DownloadStudySeries
                          seriesNumberCont={serie.SeriesNumber?.length || serie.SeriesNumber || 0}
                          studyInstance={String(seriesNumberCont)}
                        ></DownloadStudySeries>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="mt-4 flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="rounded bg-gray-600 px-4 py-2 text-white hover:bg-gray-700"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportInstances;
